import { useTheme } from 'styled-components'
import { IconBase, IconProps } from './Base'

export const IconButtonNext = (props: IconProps) => {
  const theme = useTheme()

  return (
    <IconBase width={props.width || 48} height={props.height || 48} viewBox="0 0 48 48" fill="none">
      <rect
        x="0.35"
        y="0.35"
        width="47.3"
        height="47.3"
        rx="23.65"
        stroke={theme.colors.text.primary}
        strokeWidth="0.7"
      />
      <path
        d="M20.6667 20.6667H27.3334V27.3333"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.6667 27.3333L27.3334 20.6667"
        stroke={theme.colors.text.primary}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}
